import React, { useEffect, useState } from 'react';
import { GetJson, PutJson, PostJson } from '@awp/helpers/fetchReact';
import { REST_API, FORM_MODE } from '@awp/constants';
import { useSelector } from 'react-redux';
import { Row, Col, Card, Container } from 'react-bootstrap';
import { FormInput, FormDatePicker, FormRichTextEditor } from '@awp/components/Common/AwpFormInputs';
import { Formik, Form as FormNext } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import AwpValidationErrorModal from '@awp/components/Common/AwpValidationErrorModal';
import AwpSpinner from '@awp/components/Common/AwpSpinner';
import { isValid } from 'date-fns';
import { FormCheckbox } from '@components/Common/AwpFormInputs';
import { Button } from 'react-bootstrap';
import Dropdown from '@awp/components/Common/DropDown/Dropdown';
import { convLocalToIsoString, getUtcToLocal } from '@awp/helpers/utilsReact';
import { useDispatch } from 'react-redux';
import {
  selectWeatherStation,
  setWeatherStation,
  getWxLoadingStatus,
  selectPrepWeatherStation,
} from '@stores/weatherStationSlice';
import AwpCloseCancelButtons from '../../components/AwpCloseCancelButton';
import { getCrud } from '@awp/shared/Crud';

const SystemNotificationEdit = ({
  setMode,
  mode,
  data,
  setData,
  setLoading,
  loading,
  notificationMessageData,
  setNotificationMessageData,
}) => {
  const selectAllPrepWeatherStation = selectPrepWeatherStation(mode !== FORM_MODE.CREATE);
  const allSortedWeatherStations = useSelector(selectAllPrepWeatherStation);
  const currentWSLoadingStatus = useSelector(getWxLoadingStatus);
  const [errExpiryDate, setErrExpiryDate] = useState(null);
  const [initialContent, setInitialContent] = useState('');
  const [errContent, setErrContent] = useState(null);
  const [contentInitTag, setInitContentTag] = useState(null);
  const [contentTag, setContentTag] = useState(null);
  const [entityErrors, setEntityErrors] = useState(null);
  const [isContentPristine, setContentIsPristine] = useState(true);
  const [isWSTagPristine, setWSTagPristine] = useState(true);

  const crud = getCrud('System Notification', mode);
  const { title, successMessage, errorMessage } = crud;

  const cancelConfirmMsg = `Cancel this ${mode === FORM_MODE.EDIT ? 'update' : 'create'}`;

  const dispatch = useDispatch();
  useEffect(() => {
    if (mode === FORM_MODE.CREATE) {
      setNotificationMessageData({ Name: '', Content: '' });
      return;
    }

    setLoading(true);
    const url = REST_API.SYSTEM_NOTIFICATION_MESSAGE + notificationMessageData.Id;

    GetJson(url)
      .then((response) => response.json())
      .then((data) => {
        setNotificationMessageData(data);
        parseTag(data);
        setLoading(false);
        setInitialContent(parseState(parseContent()));
      });
  }, []);

  const updateSystemNotification = (systemNotificationDto) => {
    const url = REST_API.SYSTEM_NOTIFICATION_MESSAGES + systemNotificationDto.Id;

    PutJson(url, systemNotificationDto)
      .then(async (response) => {
        if (response.ok) {
          const data = await response.json();
          saveData(data);
          setNotificationMessageData({ Name: '', Content: '' });
          toast.success(successMessage);
        } else if (response.status === 412) {
          const errors = await response.json();
          if (errors.entity) setEntityErrors({ SystemNotification: errors.entity });
          toast.error(errorMessage);
        }
      })
      .finally(() => {
        setMode(FORM_MODE.LIST);
        setNotificationMessageData(null);
      });
  };

  const createSystemNotification = (systemNotificationDto) => {
    const url = REST_API.SYSTEM_NOTIFICATION_MESSAGES;

    PostJson(url, systemNotificationDto)
      .then(async (response) => {
        if (response.ok) {
          const data = await response.json();
          saveData(data);
          toast.success(successMessage);
        } else if (response.status === 412) {
          const errors = await response.json();
          if (errors.entity) setEntityErrors({ SystemNotification: errors.entity });
          toast.error(errorMessage);
        }
      })
      .finally(() => {
        setMode(FORM_MODE.LIST);
        setNotificationMessageData(null);
      });
  };

  const cancelSystemNotification = () => {
    dispatch(setWeatherStation(null));
    setContentTag(null);
    setNotificationMessageData(null);
    setMode(FORM_MODE.LIST);
  };

  const handleSubmit = (values, { setSubmitting }) => {
    setSubmitting(true);
    const systemNotificationDto = {
      ...notificationMessageData,
      Name: values.name,
      IsUrgent: values.isUrgent ? 'Y' : 'N',
      Expirytimestamp: values.expiry == null || values.expiry == '' ? undefined : convLocalToIsoString(values.expiry),
    };

    if (mode === FORM_MODE.EDIT) {
      updateSystemNotification(systemNotificationDto);
    } else {
      createSystemNotification(systemNotificationDto);
    }
    setMode(FORM_MODE.LIST);
  };

  const saveData = (notificationMessage) => {
    if (mode === FORM_MODE.EDIT) {
      const index = data.findIndex((x) => x.Id === notificationMessage.Id);
      if (index < 0) return;
      /*if (notificationMessage.IsUrgent == 'Y') {

      }*/
      data.splice(index, 1);
    }
    if (notificationMessage.IsUrgent == 'Y') {
      data.unshift(notificationMessage);
    } else {
      sortNonUrgentNotificationMessage(notificationMessage);
    }
    setData([...data]);
    setMode(FORM_MODE.LIST);
    dispatch(setWeatherStation(null));
  };

  const sortNonUrgentNotificationMessage = (notificationMessage) => {
    const indexNonUrgent = data.findIndex((x) => x.IsUrgent == 'N');
    if (indexNonUrgent >= 0) {
      data.splice(indexNonUrgent, 0, notificationMessage);
    }
  };

  const onWSTagClear = () => {
    dispatch(setWeatherStation(null));
    let content = {};
    if (notificationMessageData.Content.length > 0) {
      content = JSON.parse(notificationMessageData.Content);
    }
    if (content?.tag != null) {
      content['tag'] = null;
      setContentTag(null);
    }
    setWSTagPristine(contentInitTag == contentTag ? false : true);
    notificationMessageData.Content = JSON.stringify(content);
  };

  const handleExpiryDateInput = (date) => {
    if (date != null) {
      if (!isValid(date)) {
        setErrExpiryDate('Expiry date is invalid.');
        return;
      } else if (date < Date.now()) {
        setErrExpiryDate('Expiry date cannot be less current date.');
        return;
      }
    }
    setErrExpiryDate(null);
    return;
  };

  const emptyValue =
    '{"root":{"children":[{"children":[],"direction":null,"format":"","indent":0,"type":"paragraph","version":1}],"direction":null,"format":"","indent":0,"type":"root","version":1}}';

  const parseContent = () => {
    if (notificationMessageData?.Content) {
      const content = JSON.parse(notificationMessageData?.Content);
      return content.editor ?? emptyValue;
    }
    return emptyValue;
  };

  const parseTag = (data) => {
    if (data?.Content) {
      const weatherStation = allSortedWeatherStations.find(
        (x) => `@${x.DisplayName}` === JSON.parse(data?.Content)?.tag,
      );
      if (weatherStation != null) {
        setContentTag(`@${weatherStation.DisplayName}`);
        setInitContentTag(`@${weatherStation.DisplayName}`);
        dispatch(setWeatherStation(weatherStation));
      }
    }
  };

  const setCurrentWeatherStationType = (id) => async (dispatch) => {
    const weatherStation = allSortedWeatherStations.find((x) => x.Id === id);
    if (weatherStation != null) {
      setWSTagPristine(contentInitTag == contentTag ? false : true);
      setContentTag(`@${weatherStation.DisplayName}`);
      dispatch(setWeatherStation(weatherStation));
      let content = {};
      if ((mode === FORM_MODE.EDIT || mode === FORM_MODE.CREATE) && notificationMessageData.Content.length > 0) {
        content = JSON.parse(notificationMessageData.Content);
      }
      content['tag'] = `@${weatherStation.DisplayName}`;
      notificationMessageData.Content = JSON.stringify(content);
    }
  };

  const isDisabled = (props) => {
    let result = isContentPristine;
    if (mode === FORM_MODE.EDIT && result && errContent == null) {
      result = ((!props.dirty || !props.isValid) && isWSTagPristine) || errExpiryDate != null;
    } else if (!result) {
      result = !props.isValid || errExpiryDate != null;
    }
    return result;
  };

  const parseState = (state) => {
    const parsed = typeof state === 'string' ? JSON.parse(state) : state;
    if (parsed.text !== undefined) {
      return parsed.text || '';
    }
    return parsed.root.children.map((node) => node.children.map((child) => child.text || '').join('')).join('\n');
  };

  const onFormRichTextEditorChange = (editorState, props) => {
    const newText = parseState(editorState.editor);
    const emptyText = parseState(emptyValue);

    if (newText === emptyText || newText === '') {
      setContentIsPristine(true);
      props.setFieldValue('content', emptyValue);
      setErrContent('Content is required');
    } else if (newText !== initialContent) {
      setContentIsPristine(false);
      setErrContent(null);
    } else {
      setContentIsPristine(true);
      setErrContent(null);
      if (props != null) {
        props.setFieldTouched('content', false);
      }
    }

    if (contentTag != null) {
      editorState = typeof editorState === 'string' ? JSON.parse(editorState) : editorState;
      editorState.tag = contentTag;
    }
    const jsonString = typeof editorState !== 'string' ? JSON.stringify(editorState) : editorState;
    notificationMessageData.Content = jsonString;
  };

  return (
    <>
      {loading ? (
        <Container>
          <AwpSpinner />
        </Container>
      ) : (
        <>
          <Formik
            initialValues={{
              name: notificationMessageData?.Name ?? '',
              isUrgent: notificationMessageData?.IsUrgent == 'Y' ?? false,
              content: parseContent(),
              expiry: notificationMessageData?.Expirytimestamp
                ? new Date(getUtcToLocal(notificationMessageData.Expirytimestamp))
                : null,
            }}
            validationSchema={Yup.object({
              name: Yup.string().max(50, 'Maximum 50 characters are allowed').optional().nullable(),
            })}
            onSubmit={handleSubmit}
          >
            {(props) => (
              <FormNext>
                <Card className="modal-card">
                  <Card.Header className="modal-card-header" style={{ paddingBottom: '5px' }}>
                    <Row className="mt-4"></Row>
                    {crud.getHeader()}
                  </Card.Header>
                  <Card.Body style={{ paddingTop: '0px', paddingBottom: '0px' }}>
                    <Row>
                      <Col sm={12} className="mb-4">
                        <FormInput label="Name (optional)" name="name" id="name" />
                      </Col>
                    </Row>
                    <Row style={{ display: 'flex', alignItems: 'end' }}>
                      <Col className="mb-4" sm={10}>
                        <Dropdown
                          ChangeHandler={setCurrentWeatherStationType}
                          AllOptions={selectAllPrepWeatherStation}
                          CurrentValue={selectWeatherStation}
                          LoadingStatus={currentWSLoadingStatus}
                          Title={'Weather Station (optional)'}
                        />
                      </Col>
                      <Col sm={2} className="mb-4" style={{ paddingLeft: '0px' }}>
                        <Button
                          style={{ float: 'right' }}
                          disabled={contentTag == null}
                          onClick={() => {
                            onWSTagClear();
                          }}
                        >
                          Clear
                        </Button>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={12}>
                        <FormRichTextEditor
                          content={parseContent()}
                          name="content"
                          id="content"
                          label="Content"
                          mode={'EDIT'}
                          onChange={onFormRichTextEditorChange}
                          props={props}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12} className="mb-4 text-danger">
                        {errContent}
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={12}>
                        <FormDatePicker
                          label="Expiry (optional)"
                          id="expiry"
                          name="expiry"
                          showTime={{ isEnabled: true }}
                          showTimeSelect={true}
                          dateFormat={['yyyy-MM-dd HH:mm']}
                          onValueChange={(date) => {
                            handleExpiryDateInput(date);
                          }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12} className="mb-4 text-danger">
                        {errExpiryDate}
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <FormCheckbox id="isUrgent" name="isUrgent" label="Urgent (optional)" />
                      </Col>
                    </Row>
                  </Card.Body>
                  <Card.Footer className="modal-card-footer" style={{ paddingBottom: '20px' }}>
                    <AwpCloseCancelButtons
                      props={props}
                      isPristine={(!props.dirty && isWSTagPristine && isContentPristine) || props.isSubmitting}
                      hasAccess={true}
                      disableSave={isDisabled(props)}
                      cancelConfirmMsg={cancelConfirmMsg}
                      onConfirmedCancel={() => {
                        cancelSystemNotification();
                      }}
                    />
                  </Card.Footer>
                </Card>
              </FormNext>
            )}
          </Formik>
          <AwpValidationErrorModal setErrors={setEntityErrors} errors={entityErrors} />
        </>
      )}
    </>
  );
};

export default SystemNotificationEdit;
